import React, { useEffect, useState } from 'react'
import { Button, Dropdown, Form } from 'semantic-ui-react'
import { Loader } from 'shared/components/Loader'

export default function CyclrLookupModalContainer({
  Modal,
  close,
  lookupModalDataSourceIndex,
  rowData,
  destinationStepId,
  lookupResponseData,
  lookupLoading,
  onAddField,
  isTemplateActive,
  onSelectTrigger,
}) {
  const [triggers, setTriggers] = useState([])
  const [lastValue, setLastValue] = useState(null)

  function onChange({ value, text }, triggerIndex) {
    const isLastTrigger = triggerIndex == triggers.length - 1
    if (isLastTrigger && !lookupResponseData.HasNextTrigger) {
      setLastValue({ value, text })
    } else {
      setTriggers((triggers) => triggers.filter((_, index) => index <= triggerIndex))
      setLastValue(null)
    }

    if (lookupResponseData.HasNextTrigger) {
      onSelectTrigger(
        {
          trigger_id: lookupResponseData.TriggerId,
          trigger_value: value,
          step_id: destinationStepId,
          entity_id: rowData.Field.Id,
          entity_type: rowData.IsParameter ? 'Parameter' : 'Field',
        },
        lookupResponseData.HasNextTrigger
      )
    }
  }

  useEffect(() => {
    if (lookupResponseData) {
      // @ts-ignore
      setTriggers((triggers) => {
        const hasTriggerId = triggers.find((i) => i.TriggerId === lookupResponseData.TriggerId)
        return hasTriggerId ? triggers : [...triggers, lookupResponseData]
      })
    }
  }, [lookupResponseData])

  useEffect(() => {
    setTriggers([])
    return () => {
      setTriggers([])
      setLastValue(null)
    }
  }, [])

  if (isTemplateActive) {
    return (
      <Modal size="tiny">
        <Modal.Header>Field lookup</Modal.Header>
        <Modal.Content>
          <p>
            You need to deactivate this integration before performing a field lookup. After you
            deactivate, perform the lookup, save the settings, then reactivate.
          </p>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={close}>Close</Button>
        </Modal.Actions>
      </Modal>
    )
  } else {
    return (
      <React.Fragment>
        <Modal size="small">
          <Modal.Header>Field lookup</Modal.Header>
          <Modal.Content>
            <CyclrLookupContent
              triggers={triggers}
              handleTriggerValueChange={onChange}
              lookupLoading={lookupLoading}
            />
          </Modal.Content>
          <Modal.Actions>
            <Button
              disabled={lookupLoading || !lastValue}
              primary
              onClick={() => {
                onAddField(
                  { value: lastValue.value, text: lastValue.text },
                  lookupModalDataSourceIndex
                )
                close()
              }}
            >
              Add field
            </Button>
          </Modal.Actions>
        </Modal>
      </React.Fragment>
    )
  }
}

function CyclrLookupContent({ triggers, handleTriggerValueChange, lookupLoading }) {
  return (
    <Form>
      {triggers.map((trigger, triggerIndex) => {
        const fieldName = trigger.FieldName
        const triggerValueOptions = trigger.TriggerValues.map((option) => {
          return { key: option.Value, text: option.Name, value: option.Value }
        })

        return (
          <Form.Field key={triggerIndex}>
            <label>{fieldName}</label>
            <Dropdown
              placeholder={`Select ${fieldName}`}
              fluid
              selection
              options={triggerValueOptions}
              onChange={(_, { value }) => {
                const selectedOption = triggerValueOptions.find((option) => option.value === value)
                if (selectedOption) {
                  handleTriggerValueChange(selectedOption, triggerIndex)
                }
              }}
            />
          </Form.Field>
        )
      })}
      {lookupLoading && <Loader withContainer />}
    </Form>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/CyclrCustomFieldForm/CyclrLookupModal/container.js